import { Box } from '@mui/material'
import styled from '@emotion/styled'

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  padding-bottom: 100px;
`

export const FieldsContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`

export const ProportionalSalaryContainer = styled(Box)`
  margin-top: 0.5rem;
`
